<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Consulta de Solicitudes de Reembolso por Descuentos Indebidos" description="" />
      <RefundForDiscountRequested/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RefundForDiscountRequested from '@/components/RefundForDiscount/RefundForDiscountRequested.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'RefundForDiscountRequestedComponentView',
  components: {
    RefundForDiscountRequested,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>